import styled from "styled-components";

/**
 * タイムライン中央に出す一行の告知（「オファー成立」「検収完了」など）。
 *
 * `SystemMessageContent` が system メッセージを描くときの既定表示であり、
 * DM 画面が system メッセージ以外の位置に同じ体裁の告知を挟むとき
 * （契約更新の成立など）にも使う。両者で枠線や色がずれないよう、
 * pill のスタイルはここを唯一の定義とする。
 *
 * 中央寄せは親（`MessageItem` の `MessageSystem` 等）が担う。
 */
const SystemNoticePill = styled.div.attrs({ className: "bodytext-11" })`
  display: inline-block;
  width: 100%;
  border: 1px solid var(--soremo-blue);
  border-radius: 999px;
  padding: 0px 16px;
  color: var(--soremo-blue);
  text-align: center;
`;

export default SystemNoticePill;
